// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import 'core-js/stable';
import 'regenerator-runtime/runtime'; // Material UI

import { InputLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DropzoneArea } from 'material-ui-dropzone';
var useStyles = makeStyles(function (theme) {
  return {
    dropzone: {
      marginTop: theme.spacing(2)
    },
    label: {
      marginBottom: theme.spacing(1)
    }
  };
});
export var ImagePicker = function ImagePicker(_ref) {
  var label = _ref.label,
      fileTypes = _ref.fileTypes,
      required = _ref.required,
      onAdd = _ref.onAdd,
      onDelete = _ref.onDelete,
      maxFileSize = _ref.maxFileSize,
      showFilenames = _ref.showFilenames;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.dropzone
  }, /*#__PURE__*/React.createElement(InputLabel, {
    className: classes.label
  }, label), /*#__PURE__*/React.createElement(DropzoneArea, {
    acceptedFiles: fileTypes,
    dropzoneText: (required ? 'Image required. ' : '') + "Drag-and-drop or click to upload image",
    filesLimit: 1,
    maxFileSize: maxFileSize,
    showFileNames: showFilenames,
    onDelete: onDelete,
    onDrop: onAdd
  }));
};
ImagePicker.propTypes = {
  fileTypes: PropTypes.arrayOf(PropTypes.string),
  label: PropTypes.string,
  maxFileSize: PropTypes.number,
  onAdd: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  required: PropTypes.bool,
  showFilenames: PropTypes.bool
};
ImagePicker.defaultProps = {
  fileTypes: ['image/jpeg', 'image/png'],
  maxFileSize: 5000000,
  required: false,
  showFilenames: true
};